import React from 'react';

import BaseIcon from '../BaseIcon';

export const Circle = (props) => (
    <BaseIcon {...props} viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="25" fill={props.color} />
    </BaseIcon>
);
